import { render, staticRenderFns } from "./fixed-right.vue?vue&type=template&id=6abf73f8&scoped=true&"
import script from "./fixed-right.vue?vue&type=script&lang=js&"
export * from "./fixed-right.vue?vue&type=script&lang=js&"
import style0 from "./fixed-right.vue?vue&type=style&index=0&id=6abf73f8&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abf73f8",
  null
  
)

export default component.exports